import { Link } from "react-router-dom";
import DatafieldSection, {
  DatafieldLabel,
} from "../../../components/datafield-section";
import { RetailODDetails, TermLoanDetails, UserDetails } from "../../../dto";
import { EnterpriseDetails } from "../../../dto/enterprise.dto";
import { RoutePaths } from "../../../models";

interface BorrowerDetailsProps {
  userDetails: UserDetails | EnterpriseDetails | null;
  loanDetails: TermLoanDetails | RetailODDetails | null;
}

interface UserIdLinkProps {
  loan: TermLoanDetails | RetailODDetails | null;
}

function UserIdLink({ loan }: UserIdLinkProps) {
  if (!loan) return null;

  const { userId, enterpriseId } = loan;
  const entityId = enterpriseId ?? userId;
  if (!entityId) return null;

  const path = enterpriseId
    ? `${RoutePaths.ENTERPRISE_USERS}/${entityId}`
    : `${RoutePaths.INDIVIDUAL_USERS}/${entityId}`;

  return <Link to={path}>{entityId}</Link>;
}

export default function BorrowerDetails({
  loanDetails,
  userDetails,
}: BorrowerDetailsProps) {
  const BORROWER_DETAILS_LABEL_MAP: DatafieldLabel[] = [
    {
      items: [
        {
          label: "Borrower ID",
          key: ["userId", "enterpriseId"],
          formatMethod: () => <UserIdLink loan={loanDetails} />,
        },
        {
          label: "Borrower Name",
          key: "name.data",
        },
      ],
    },
    { items: [{ label: "Borrower PAN", key: "pan.data.pan" }] },
  ];

  if (
    !loanDetails ||
    (loanDetails.loanType !== "TERM_LOAN" &&
      loanDetails.loanType !== "RETAIL_OD")
  )
    return null;

  const data = {
    ...userDetails,
    ...loanDetails,
  };

  return (
    <DatafieldSection
      title="Borrower Details"
      labels={BORROWER_DETAILS_LABEL_MAP}
      data={data}
    />
  );
}
